if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

    const accordionBlocks = document.querySelectorAll('.accordion-block');

    if (accordionBlocks.length > 0) {
		accordionBlocks.forEach(accordionBlock => {
			let allAccordionItems = accordionBlock.getElementsByClassName('js-accordion-title');

			for (let i = 0; i < allAccordionItems.length; i++) {
				allAccordionItems[i].addEventListener('click', function () {
					let currentParent = this.parentElement;
					let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
					let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
					
					if(currentParent.classList.contains('open')){
						currentParent.classList.remove('open');
						currentCopy.style.height = '0';
					} else {
						currentParent.classList.add('open');
						currentCopy.style.height = currentCopyHeight + 'px';
					}
				});
			}
		});
	}

    document.addEventListener("DOMContentLoaded", function () {
        const toggleButtons = document.querySelectorAll("[id^='buttons-watch']");
        toggleButtons.forEach((toggleButton) => {
            const entryId = toggleButton.id.split("-")[2];
            const buttonsDiv = document.getElementById(`buttons-div-${entryId}`);
            toggleButton.addEventListener("click", function (e) {
                e.preventDefault();
                if (buttonsDiv.style.display === "none") {
                    buttonsDiv.style.display = "block";
                } else {
                    buttonsDiv.style.display = "none";
                }
            });
        });
    });
})();

